import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <h2>About Our Notary Services</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              Our notary public services are designed to provide reliable, efficient, and professional document 
              authentication for individuals and businesses throughout Ontario. We understand that legal documentation 
              requires precision, trust, and accessibility.
            </p>
            <p>
              Whether you need assistance with real estate transactions, business agreements, personal affidavits, 
              or any other legal documents requiring notarization, our professional service ensures accuracy and 
              compliance with Ontario legal requirements.
            </p>
          </div>
          <div className="about-choose-us">
            <h3>Why Choose Our Services?</h3>
            <ul>
              <li>🕐 24/7 Availability - Service When You Need It Most</li>
              <li>🌐 Flexible Service Options - Online, In-Person, or Mobile</li>
              <li>⚡ Express Processing - Quick Turnaround Times</li>
              <li>🎯 Ontario-Wide Coverage - Serving All of Ontario</li>
              <li>💼 Corporate & Personal Services - All Document Types</li>
              <li>✅ Licensed & Insured - Professional Standards Maintained</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;